import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import '../side-Nav/side-Nav.css';
import dashboardIcon from '../../assets/images/dashboard.svg';
import dashboardActiveIcon from '../../assets/images/dashboardactive.svg';
import ReportIcon from '../../assets/images/Report.svg';
import ReportActiveIcon from '../../assets/images/Reportactive.svg';
import createnew_8D from '../../assets/images/createnew_8D.svg';
import createnew_8DActive from '../../assets/images/createnew_8Dactive.svg';
import AdminIcon from '../../assets/images/Admin.svg';
import AdminActiveIcon from '../../assets/images/AdminAct.svg';
import { fetchUserAccess, hasRouteAccess, getIsSupplier, onAccessLoaded } from '../../services/roleAccessService';

const DashboardLayout = ({ screenWidth, currentUser, open, onStateChange }) => {
  const navigate = useNavigate();
  const [accessLoaded, setAccessLoaded] = useState(false);

  useEffect(() => {
    fetchUserAccess().then(() => setAccessLoaded(true));
    onAccessLoaded(() => setAccessLoaded(true));
  }, []);

  const isSupplier = getIsSupplier();
  const canAccess = (path) => accessLoaded ? hasRouteAccess(path) : false;

  const isSideNavOpen = open;
  const sideNavMode = screenWidth > 840 ? 'side' : 'over';

  return (
    <div className={`sidenav-container mode-${sideNavMode}`}>
      <nav className={`sidenav mat-elevation-z4 ${isSideNavOpen ? 'open' : 'closed'}`}>
        <ul className="text-center">
          <li>
            <NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active-link' : ''}>
              <img src={dashboardIcon} alt="Dashboard" className="defalutIcon" />
              <img src={dashboardActiveIcon} alt="Dashboard" className="activeIcon" />
              <span>Dashboard</span>
            </NavLink>
          </li>
          {canAccess('8D-forms') && (
            <li>
              <NavLink to="/8D-forms" className={({ isActive }) => isActive ? 'active-link' : ''}>
                <img src={ReportIcon} alt="8D's" className="defalutIcon" />
                <img src={ReportActiveIcon} alt="8D's" className="activeIcon" />
                <span>8D's</span>
              </NavLink>
            </li>
          )}
          {/* Access decided by role assigned in UserMaster/RoleMaster for all users including B2C */}
          {canAccess('create-new') && (
            <li>
              <NavLink to="/create-new" className={({ isActive }) => isActive ? 'active-link' : ''}>
                <img src={createnew_8D} alt="Create New" className="defalutIcon" />
                <img src={createnew_8DActive} alt="Create New" className="activeIcon" />
                <span>Create New</span>
              </NavLink>
            </li>
          )}
          {canAccess('reports') && (
            <li>
              <NavLink to="/reports" className={({ isActive }) => isActive ? 'active-link' : ''}>
                <img src={ReportIcon} alt="Reports" className="defalutIcon" />
                <img src={ReportActiveIcon} alt="Reports" className="activeIcon" />
                <span>Reports</span>
              </NavLink>
            </li>
          )}
          {/* Access decided by role assigned in UserMaster/RoleMaster for all users including B2C */}
          {(canAccess('masters/user-master') || canAccess('masters/role-master')) && (
            <li className="has-submenu">
              <a href="#" className="menu-title" onClick={(e) => e.preventDefault()}>
                <img src={AdminIcon} alt="Masters" className="defalutIcon" />
                <img src={AdminActiveIcon} alt="Masters" className="activeIcon" />
                <span>Masters</span>
              </a>
              <ul className="submenu">
                {canAccess('masters/user-master') && (
                  <li>
                    <NavLink to="/masters/user-master" className={({ isActive }) => isActive ? 'active-link' : ''}>
                      <span>User Master</span>
                    </NavLink>
                  </li>
                )}
                {canAccess('masters/role-master') && (
                  <li>
                    <NavLink to="/masters/role-master" className={({ isActive }) => isActive ? 'active-link' : ''}>
                      <span>Role Master</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </li>
          )}
          <li className="mobileDisplay">
            <NavLink to="/logout" className={({ isActive }) => isActive ? 'active-link' : ''}>
              <img src="/assets/images/logout.svg" alt="Logout" className="defalutIcon" />
              <span>Logout</span>
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default DashboardLayout;
